export default {
  'form.text.title': '',
  'form.text.postulationDone': 'Application successfully completed',
  'form.text.number': 'Application No.: {name}',
  'form.text.documents': 'Documents',
  'form.message.noCaptcha': 'reCaptcha validation error, please try again in a few seconds.',
  'form.text.continueDone': 'The action has been completed successfully!',
  'form.text.cleanForm': 'Clear form',
  'form.text.refresh.title': 'Would you like to clear the form?',
  'form.text.refresh.content': 'This action will delete your responses and cannot be undone.',
  'form.text.telegramUser': 'Telegram Identifier',
  'form.text.userName': 'User',
  'form.text.userFirstName': 'Names',
  'form.text.userLastNames': 'Last Names',
  'form.text.fullName': 'Full Name',
  'form.text.email': 'Email',
  'form.text.hash': 'Hash',
  'form.text.token': 'Token',
  'form.telegram.account': 'Account Confirm',
  'form.telegram.title': `Confirm that you want to link the Telegram account with your AUTOMY account.`,
  'form.telegram.group': 'Telegram / User Information',
  'form.telegram.automy': 'Automy / User Information',
  'form.telegram.help': `By confirming, you agree to AUTOMY sending notifications about requests to your Telegram account.`,
  'form.telegram.message': `The Telegram link information has been successfully verified.`,
  'form.telegram.unauthorized': `You must be authenticated to verify your Telegram account.`,
};
